/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1QuizAdminQuestionsListPool = typeof V1QuizAdminQuestionsListPool[keyof typeof V1QuizAdminQuestionsListPool];


export const V1QuizAdminQuestionsListPool = {
  main: 'main',
  weekend: 'weekend',
} as const;
